/** Кривая цены `CostCurve`: `base · (1000 + growth)^level / 1000^level`, округление вниз (точно, на BigInt). */
import { PERMILLE, type CostCurve } from "@newfungame/contracts";

const MAX_SAFE = BigInt(Number.MAX_SAFE_INTEGER);

/** Цена шага `level → level + 1`. Бросает `RangeError` на нецелом/отрицательном уровне и при выходе за safe integer. */
export function curveCost(curve: CostCurve, level: number): number {
  if (!Number.isInteger(level) || level < 0) throw new RangeError(`curveCost: bad level ${level}`);
  const l = BigInt(level);
  const v = (BigInt(curve.base) * BigInt(PERMILLE + curve.growthPermille) ** l) / BigInt(PERMILLE) ** l;
  if (v > MAX_SAFE) throw new RangeError(`curveCost: cost at level ${level} exceeds a safe integer`);
  return Number(v);
}

/** Сумма шагов `from → to` (уровни `from … to − 1`). */
export function curveTotal(curve: CostCurve, from: number, to: number): number {
  let sum = 0;
  for (let level = from; level < to; level++) sum += curveCost(curve, level);
  return sum;
}
